import React, {
  useCallback,
  useEffect,
} from 'react'

import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'

import {
  Field,
  reduxForm,
} from 'redux-form'

import {
  useDispatch,
  useSelector,
} from 'react-redux'

import { Button } from '@termly/react-components'

import FormIds from 'constants/formIds/policyMigrator'

import HeapAPI from 'utils/heap-api'

import {
  handleCancelMigratePolicy,
  handleSubmit,
} from 'sagas/forms/policyMigrator'

import * as PolicyMigratorSelectors from 'selectors/forms/policyMigrator'

import Select from 'components/Select'

import WarningIcon from 'assets/images/ico-warning-2.svg'

import Locale from './locale'
import Styles from './styles.scss'

const HEAP_EVENT = 'migrate-policy-modal-shown'
const CREATE_POLICY_DATA_TRACKING = 'migrate-policy-saved'
const DISCARD_POLICY_DATA_TRACKING = 'migrate-policy-discarded'

const BUTTON_CLASS_NAME = classnames(Styles.submitButton, 't-submitButton')
const DELETE_CLASS_NAME = classnames(Styles.deleteButton, 't-deleteButton')


// TODO: Get rid of this ReduxForm stuff
export default reduxForm({
  form: FormIds.name,
  onSubmit() {
  },
})(PolicyMigrator)

function PolicyMigrator() {
  const dispatch = useDispatch()

  useEffect(() => {
    HeapAPI.track(HEAP_EVENT)
  }, [])

  const documentName = useSelector(PolicyMigratorSelectors.getDocumentName)
  const formData = useSelector(PolicyMigratorSelectors.getFormData)
  const isSubmitting = useSelector(PolicyMigratorSelectors.getIsSubmitting)
  const migratedDocument = useSelector(PolicyMigratorSelectors.getMigratedDocument)
  const selectorOptions = useSelector(PolicyMigratorSelectors.getWebsiteSelectorOptions)
  const shouldShowErrorOverride = useSelector(PolicyMigratorSelectors.getShouldOverrideDocument)

  const handleClickSubmit = useCallback(() => {
    const {
      document,
      override,
    } = formData

    dispatch(handleSubmit({
      override,
      documentID: migratedDocument.id,
      websiteID: document.website_id,
    }))
  }, [dispatch, formData, migratedDocument])

  const onClickDelete = useCallback((e) => {
    e.stopPropagation()

    dispatch(handleCancelMigratePolicy({
      documentID: migratedDocument.id,
      websiteID: migratedDocument.website_uuid,
    }))
  }, [dispatch, migratedDocument])

  const isButtonDisabled = Boolean(!formData.document.website_id || isSubmitting)

  return (
    <div className={ Styles.root }>
      <div className={ Styles.title }>
        <FormattedMessage
          { ...Locale.titlePolicyMigrator }
          values={ { documentName } }
        />
      </div>

      <p className={ Styles.warning }>
        <FormattedMessage
          { ...Locale.warning }
          values={ { documentName } }
        />
      </p>

      {
        renderOverrideWarning({
          shouldShowErrorOverride,
        })
      }

      <Field
        { ...selectorOptions }
        arrow="blue-arrow"
        component={ Select }
        label={ Locale.labelSelectWebsites }
        name={ FormIds.fields.websiteId }
        placeholder={ Locale.placeholderSelectWebsite }
      />

      <div className={ Styles.footer }>
        <div
          className={ DELETE_CLASS_NAME }
          data-tracking={ DISCARD_POLICY_DATA_TRACKING }
          onClick={ onClickDelete }
        >
          <FormattedMessage
            { ...Locale.buttonDelete }
          />
        </div>
        <Button
          className={ BUTTON_CLASS_NAME }
          color="secondary"
          data-tracking={ CREATE_POLICY_DATA_TRACKING }
          disabled={ isButtonDisabled }
          handleClick={ handleClickSubmit }
          type="solid"
        >
          <FormattedMessage
            { ...Locale.save }
          />
        </Button>
      </div>
    </div>
  )
}

function renderOverrideWarning({ shouldShowErrorOverride }) {
  if ( !shouldShowErrorOverride ) {
    return null
  }

  return (
    <div className={ Styles.overrideNotice }>
      <img
        className={ Styles.errorIcon }
        src={ WarningIcon }
      />
      <div className={ Styles.errorContent }>
        <FormattedMessage
          { ...Locale.errorMessageReplacePolicy }
        />
      </div>
    </div>
  )
}

